import { computed, ref } from 'vue';
import { IssueTemplateEditable } from '@/ui/DTO';
import { IssueTemplateBuilderEditable } from '@/ui/DTO/issueTemplateBuilderEditable';
import { IssueLegacy, jsonIssueToIssueTemplateEditableAdaptor } from '@/ui/pages/checklist/adaptors/IssueAdaptors';

// state
export const actions = ref<Array<IssueTemplateEditable>>([]);
export const undeletedActions = computed(() => actions.value.filter(a => !a.softDeleted));
export const issueBeingEdited = ref<IssueTemplateBuilderEditable | null>(null);

// actions
export const updateAction = (action: IssueTemplateEditable) => {
  actions.value.splice(
    actions.value.findIndex(a => a.internalId === action.internalId)!,
    1,
    {
      ...action,
      wasChanged: true,
    },
  );
};

export const addAction = (action: IssueTemplateEditable) => {
  actions.value.push(action);
};

export const removeAction = (action: IssueTemplateEditable) => {
  actions.value.splice(
    actions.value.findIndex(a => a.internalId === action.internalId)!,
    1,
    {
      ...action,
      softDeleted: true,
    },
  );
};

export const setIssueBeingEditedFromLegacy = (issueLegacy: IssueLegacy) => {
  issueBeingEdited.value = jsonIssueToIssueTemplateEditableAdaptor(issueLegacy);
};
